/* eslint-disable padding-line-between-statements */
import React, { useCallback, useState, useEffect } from 'react';
import { Loader, useModal, Icon } from '@jutro/components';
import _ from 'lodash';
import { withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import { withRouter, useLocation, Link } from 'react-router-dom';
import { useTranslator } from '@jutro/locale';
import moment from 'moment';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { useAciUtil, useTypelistUtil } from 'ent-capability-hooks';
import PropTypes from 'prop-types';
import  { TwiaBillingService }  from 'ent-capability-policybilling';
import { AccountBillingDetailsService } from 'gw-capability-billing';
import AccountConfirmationPopup from '../AccountConfirmationPopup/AccountConfirmationPopup';
import messages from './ManagePaymentMethodsPage.messages';
import metadata from './ManagePaymentMethodsPage.metadata.json5';
import styles from './ManagePaymentMethodsPage.module.scss';

function ManagePaymentMethodsPage(props) {
    const {
        authHeader,
        history,
        onResolve,
        onReject,
        onAfterClose
     } = props;
    const { getTypelistName } = useTypelistUtil('bc', 'typekey.PaymentMethod');
    const [paymentInstruments, setPaymentInstruments] = useState([]);
    const [accountNos, setAccountNos] = useState([]);
    const [selectedAccountNumber, setSelectedAccountNumber] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [isSynced, setIsSynced] = useState(false);
    const [accountsLoaded, setAccountsLoaded] = useState(false);
    const [activeAPICall, setActiveAPICall] = useState(false);
    const [updatingValues, setUpdatingValues] = useState(false);
    const [ accountInvoiceStream, setAccountInvoiceStream] = useState([]);
    const [, updateState] = useState({});
    const [/* disablePayNow */, setDisablePayNow] = useState(false);
    const [/* selectedPaymentInstrument */, setSelectedPaymentInstrument] = useState({});
    const { showConfirm, showModal } = useModal();
    const translate = useTranslator();
    const location  = useLocation();
    const {editPaymentInstrumentForAccount, generateModalError, createOrUpdatePaymentInstrument } = useAciUtil();
    const [autoPayInstrumentsList, setAutoPayInstrumentsList] = useState([]);

    const generateAutoPayInstrumentList = useCallback( (ais) => {
        setIsLoading(true);
         const instrList = [];
         if (!_.isEmpty(ais)) {     
             ais.invoiceStreams.forEach( (is) => {
                 if (is.autoPayEnabled){
                    setActiveAPICall(true);
                     // update the autoPayInstrument List
                    TwiaBillingService.getInvoiceStreamAutoPayData(is.internalId, false, authHeader)
                     .then((apd) => {
                        if (!_.isNull(apd.autoPayInstrument)){
                            instrList.push(apd.autoPayInstrument.publicID);
                        }
                        
                     });
                     setActiveAPICall(false);
                 }
             });            
             setAutoPayInstrumentsList(instrList);
             setIsLoading(false);  
         }
    }, [authHeader]);

    const checkForAutoPayInstruments = useCallback( (selectedInstrumentForDeletion) => {
        setIsLoading(true);
        if (!_.isEmpty(accountInvoiceStream)){ 
            if (!_.isEmpty(autoPayInstrumentsList)) {
                const found = autoPayInstrumentsList.find((ap) => ap === selectedInstrumentForDeletion.publicID);   
                if (!_.isUndefined(found)){
                    setIsLoading(false);
                    return true;
                }
            }
            setIsLoading(false);
            return false; 
        }
        setIsLoading(false);
        return false;
    }, [accountInvoiceStream, autoPayInstrumentsList]);


    useEffect(() => {
        setIsLoading(true);       
        // Call to create new payment instrument in BC
        if (!_.isEmpty(location.search) && authHeader){   
            setIsLoading(true);     
            setUpdatingValues(true);
            const searchParams = new URLSearchParams(location.search);       
            if (!updatingValues){
                createOrUpdatePaymentInstrument(searchParams, history, authHeader);
                setUpdatingValues(false);
            }     
            // force a page reload
            history.push('/manage-payment-methods');
            updateState({});
            setIsLoading(false);
        } else {     
            setIsLoading(true);
            // Load all payment Instruments
            if (_.isEmpty(paymentInstruments) && authHeader){       
                setActiveAPICall(true);
                if (!isSynced){
                    TwiaBillingService.getAllSyncedPaymentInstruments(false, authHeader ).then((syncedInstruments)=>{
                        if (!_.isEmpty(syncedInstruments)){                  
                            const orderedInstruments =  _.sortBy(syncedInstruments, 'description');
                            setPaymentInstruments(orderedInstruments);
                        }
                    });
                    setIsSynced(true);
                }
               
                setActiveAPICall(false);
            }
        
            // Load all account numbers
            if(_.isEmpty(accountNos) && authHeader){
                setActiveAPICall(true);
                if (!accountsLoaded){
                    TwiaBillingService.getAvailableAccountNumbers(authHeader).then ((response) => {
                        setAccountNos(response);
                    });
                    setAccountsLoaded(true)
                }
               
                setActiveAPICall(false);
            }
    
            // use the paymentInstrument declared above to determine auto payment enabled or not.      
            // add  a check to see if payment instruments are available as well well. 
            if (_.isEmpty(accountInvoiceStream) && authHeader && !_.isEmpty(paymentInstruments)){
                setActiveAPICall(true);
                AccountBillingDetailsService.getAccountInvoiceStreamInformation(authHeader).then((ais) => {
                    setAccountInvoiceStream(ais);   
                    if (_.isEmpty(autoPayInstrumentsList)){
                        setIsLoading(true);
                        generateAutoPayInstrumentList(ais);
                    } 
                }); 
                setActiveAPICall(false);
            }

            setIsLoading(false);
       }
        
       setIsLoading(false);
       
   
    }, [accountInvoiceStream, accountNos, accountsLoaded, authHeader, autoPayInstrumentsList, createOrUpdatePaymentInstrument, generateAutoPayInstrumentList, history, isSynced, location.search, paymentInstruments, updatingValues]);

    const getCell = (item, index, property) => item[property.id];

    
    const getFormattedDate = useCallback(
        (item, index, property) => 
        {
            if (_.isUndefined(item[property.id])){
                return undefined;
            }

            const aDate = moment(item[property.id]);

            return (aDate.format("MM/YY"));
        }, [] );


    // eslint-disable-next-line consistent-return
    const getPaymentNameCell = useCallback((item, index, property) => {
        const typeName = getTypelistName(item[property.id])?.toLowerCase();
        
        if (!_.isUndefined(typeName)){
             let instrumentDisplayName;
    
            if (typeName.includes('credit')){
                instrumentDisplayName = "Credit Card";
            } else if (typeName.includes('debit')){
                instrumentDisplayName = "Debit Card";
            } else {
                instrumentDisplayName = "Bank Account"
            }
    
            return instrumentDisplayName;
            }
       
    }, [getTypelistName]);
        

    const handleAddPaymentInstrument = useCallback(() => {
        let currState = {
            action : 'new',
            accountNumber: selectedAccountNumber
        };

        currState = window.encodeURIComponent(window.btoa(JSON.stringify(currState)));

        const accountDetails = {selectedAccountNumber, accountNos};
        
        const componentProps = {
            accountDetails,
            currState,
            authHeader,
            history,
            isOpen: true,
            onResolve,
            onReject,
            onAfterClose
        };

       const getAccountNumber = showModal( <AccountConfirmationPopup {...componentProps} />);

       setSelectedAccountNumber(getAccountNumber);
     
    }, [accountNos, authHeader, history, onAfterClose, onReject, onResolve, selectedAccountNumber, showModal]);



    const handleEditPaymentInstrument = useCallback((payIns) => {
        setSelectedPaymentInstrument(payIns);

        if (!activeAPICall) {
            try {
                let currState = {
                    action: 'edit',
                    accountNumber: payIns.accountNumber
                };
        
                currState = window.encodeURIComponent(window.btoa(JSON.stringify(currState)));
                window.scrollTo(0, 0);
                setActiveAPICall(true);
                editPaymentInstrumentForAccount(payIns, currState, authHeader)
                setActiveAPICall(false);
            }
            catch (e){
                setActiveAPICall(false);
            }
        }
      
    }, [activeAPICall, authHeader, editPaymentInstrumentForAccount]);


    const handleDeletePaymentInstrument = useCallback((payIns, msgs) => {
        setSelectedPaymentInstrument(payIns);
        showConfirm({
           title: translate(msgs.deletePaymentMethodTitle),
           message: translate(msgs.deletePaymentMethodDesc),
           status: 'info',
           // icon:  'mi-error-outline',
           confirmationText: translate(msgs.paymentInstrumentRemoveConfirmYes),
           cancellationText: translate(msgs.paymentInstrumentRemoveConfirmNo)
        }).then( async (results) => {
            if (results === 'cancel' || results === 'close'){
                return _.noop();
            }

            if (!activeAPICall){
                setActiveAPICall(true);

                try{
                    const checkIfAutoPayEnabledInstrument = checkForAutoPayInstruments(payIns);
                    
                    if (checkIfAutoPayEnabledInstrument){
                        generateModalError(messages.deletePaymentMethodTitle, messages.deleteInstrumentForAutoPay);
                        setActiveAPICall(false);
                    } else {
                        TwiaBillingService.deletePaymentInstrument(payIns.accountNumber, payIns.lobcode, payIns.token, authHeader).then ((pis) => {
                            setPaymentInstruments(pis);
                            setActiveAPICall(false);
                        }).catch((e) =>{
                            const errorCode = _.get(e, 'baseError.error.data.appErrorCode');
    
                            setActiveAPICall(false);
    
                            if (errorCode === 10004) {
                                generateModalError(messages.deletePaymentMethodTitle, messages.deletePaymentMethodError);
                            } else {
                                generateModalError(messages.deletePaymentMethodTitle, messages.deletePaymentMethodGeneralError);
                            }
                
                        });
                    }
                   
                } catch(e) {
                    setActiveAPICall(false);
                    setDisablePayNow(true);
                }
            }  

            return true;
        }, _.noop);

    }, [activeAPICall, authHeader, checkForAutoPayInstruments, generateModalError, showConfirm, translate]);


    const getEditIcon = useCallback(
        (item, index, property) =>( 
            <Link 
                href={item[property.id]} 
                to='manage-payment-methods'
                onClick={() => handleEditPaymentInstrument(item)} 
                className={styles.trashLink} 
            >
                <Icon icon="mi-edit" className={styles.trashLink} />
            </Link>
        ), [handleEditPaymentInstrument]);

    const getRemoveIcon = useCallback(
        (item, index, property) =>( 
            <Link 
                href={item[property.id]} 
                to='manage-payment-methods'
                onClick={() => handleDeletePaymentInstrument(item, messages)} 
                className={styles.trashLink} 
            >
                 <Icon icon="mi-delete" className={styles.trashLink} />
            </Link>
        ), [handleDeletePaymentInstrument]);

    const overrideProps = {
        tablePaymentMethods: {
            visible: !_.isUndefined(paymentInstruments),
            data: paymentInstruments,
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            handleAddPaymentInstrument,
            handleEditPaymentInstrument,
            handleDeletePaymentInstrument,
            getFormattedDate,
            getCell,
            getRemoveIcon,
            getEditIcon,
            getPaymentNameCell
        },
    };

    if (isLoading) {
        return <Loader loaded={!isLoading} />;
    }


    return (
        <Loader loaded={!isLoading}>
            <MetadataContent
                uiProps={metadata.componentContent}
                model={paymentInstruments}
                overrideProps={overrideProps}
                {...resolvers}
            />
        </Loader>
    );
}

ManagePaymentMethodsPage.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func,
    }).isRequired,
    authHeader: PropTypes.shape({}).isRequired,
};

export default withAuthenticationContext(withRouter(ManagePaymentMethodsPage));
